import { statusColors } from 'helpers/status.colors'
import './index.scss'

type StatusLabelProps = {
    label: string
    count: number
    isChecked: boolean
    onChange: (label: string, checked: boolean) => void
}

const getStatusColor = (label: string): string => {
    return statusColors[label.toUpperCase()] || '#444'
}

export const StatusLabel: React.FC<StatusLabelProps> = ({
    label,
    count,
    isChecked,
    onChange,
}) => {
    if (count <= 0) return null

    const color = getStatusColor(label)

    return (
        <label
            className={`status-label ${isChecked ? 'checked' : ''}`}
            style={
                {
                    '--status-color': color,
                    color,
                    backgroundColor: `${color}20`,
                    borderColor: isChecked ? color : 'transparent',
                } as React.CSSProperties
            }
        >
            <input
                type="checkbox"
                checked={isChecked}
                onChange={() => onChange(label, !isChecked)}
                className="status-checkbox"
            />
            <span className="custom-checkbox" />
            {label}: {count}
        </label>
    )
}
